import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { PatientAccumulatorComponent } from './patient-accumulator.component';
import { AccumulatorGridModule } from 'src/app/shared/accumulator-grid/accumulator-grid.module';

@NgModule({
  imports: [
    SharedModule,
    AccumulatorGridModule
  ],
  declarations: [
    PatientAccumulatorComponent
  ],
  exports: [
    PatientAccumulatorComponent
  ]
})
export class PatientAccumulatorModule { }
